import { GRD } from "@/constants/testIds";
import {
  SAMPLE_BODY_HTML,
  previewValuesForPage,
  resolveReportHtml,
} from "@/lib/genericReportPlaceholders";

function PreviewPage({
  label,
  headerHtml,
  footerHtml,
  headerClassName,
  testId,
  pageNumber,
}) {
  const values = previewValuesForPage(pageNumber);
  return (
    <article className="grd-page" data-testid={testId}>
      <p className="grd-page__label">{label}</p>
      <header
        className={headerClassName}
        dangerouslySetInnerHTML={{ __html: resolveReportHtml(headerHtml, values) }}
      />
      <section
        className="grd-page__body"
        dangerouslySetInnerHTML={{ __html: SAMPLE_BODY_HTML }}
      />
      <footer
        className="grd-page__footer"
        dangerouslySetInnerHTML={{ __html: resolveReportHtml(footerHtml, values) }}
      />
    </article>
  );
}

export default function ReportPrintPreview({
  firstPageHeaderHtml,
  subsequentHeaderHtml,
  footerHtml,
}) {
  return (
    <div className="grd__preview-wrap" data-testid={GRD.preview}>
      <div className="grd-preview-grid">
        <PreviewPage
          label="First page"
          headerHtml={firstPageHeaderHtml}
          footerHtml={footerHtml}
          headerClassName="grd-page__header"
          testId={GRD.previewFirstPage}
          pageNumber={1}
        />
        <PreviewPage
          label="Subsequent page"
          headerHtml={subsequentHeaderHtml}
          footerHtml={footerHtml}
          headerClassName="grd-page__header grd-page__header--compact"
          testId={GRD.previewSubsequentPage}
          pageNumber={2}
        />
      </div>
    </div>
  );
}
